module.exports = __webpack_public_path__ + "static/img/1234.5ddbfdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/nxzw/1234.png
// module id = k4Ds
// module chunks = 0